export const TOGGLE_THEME = 'TOGGLE_THEME'
export const CHECK_THEME = 'CHECK_THEME'
export const SUBSCRIBE = 'SUBSCRIBE'
export const UNSUBSCRIBE = 'UNSUBSCRIBE'
export const CHECK_SUBSCRIPTION = 'CHECK_SUBSCRIPTION'
export const CHANGE_COLOR = 'CHANGE_COLOR'
export const CHECK_COLOR = 'CHECK_COLOR'
export const RESET_COLOR = 'RESET_COLOR'
